var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container main" },
    [
      _c("div", { staticClass: "menu" }, [
        _c(
          "button",
          {
            staticClass: "sendbtn",
            on: {
              click: function($event) {
                _vm.showDialog(undefined, "发消息")
              }
            }
          },
          [_vm._v("+发消息")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "btn_list" }, [
          _c(
            "div",
            {
              staticClass: "inbox item cursor",
              class: { selected: _vm.selecetedList[0] },
              on: {
                click: function($event) {
                  _vm.goSection("inbox", "all", 0)
                }
              }
            },
            [
              _c("i", {
                staticClass: "fa fa-inbox ",
                staticStyle: { "margin-right": "10px" }
              }),
              _c("span", [_vm._v("收件箱")])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "sendbox item cursor",
              class: { selected: _vm.selecetedList[1] },
              on: {
                click: function($event) {
                  _vm.goSection("outbox", "", 1)
                }
              }
            },
            [
              _c("i", {
                staticClass: "fa fa-envelope-o",
                staticStyle: { "margin-right": "10px" }
              }),
              _c("span", [_vm._v("发件箱")])
            ]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "btn_list category" },
          [
            _c("span", { staticClass: "category_label" }, [_vm._v("分类")]),
            _vm._v(" "),
            _vm._l(_vm.categoryList, function(item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "inbox item cursor",
                  class: { selected: _vm.selecetedList[index + 2] },
                  on: {
                    click: function($event) {
                      _vm.goSection("inbox", item.name, index + 2)
                    }
                  }
                },
                [
                  _c("i", {
                    staticClass: "fa fa-circle",
                    staticStyle: { "margin-right": "10px" },
                    style: { color: item.color }
                  }),
                  _c("span", [_vm._v(_vm._s(item.label))])
                ]
              )
            })
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "section main" },
        [
          _c(_vm.unitName, {
            ref: "box",
            tag: "component",
            attrs: {
              category: _vm.category,
              ajax: _vm.ajax,
              config: _vm.config
            },
            on: {
              detail: function($event) {
                _vm.showDialog($event, "消息详情")
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialogTilte,
            visible: _vm.dialogVisible,
            width: _vm.dialogWidth
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _vm.dialogType == "editor"
            ? _c("editor", {
                attrs: { show: _vm.dialogVisible },
                on: { close: _vm.doClose }
              })
            : _vm.dialogType == "detail"
              ? _c("detail", {
                  attrs: {
                    obj: _vm.props,
                    show: _vm.dialogVisible,
                    ajax: _vm.ajax,
                    config: _vm.config
                  }
                })
              : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b7f252a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b7f252a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/notice/index.vue
// module id = null
// module chunks = 